import { Banner } from "@primer/react";
import "./MessageBox.css";

const variants = {
  information: "info",
  success: "success",
  warning: "warning",
  danger: "critical"
};

export function MessageBox({ children, heading, tone = "information" }) {
  return <Banner className="message-box" variant={variants[tone]} title={heading} description={children} layout="compact" />;
}
